import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';

class SmsMessageRecipientsService extends BaseService<
	SmsMessageRecipient,
	'smsMessageRecipientID',
	'smsMessageRecipients'
> {
	constructor() {
		super(
			'smsMessageRecipientID',
			'smsMessageRecipient',
			'smsMessageRecipients',
		);
	}

	async getAllBySmsMessageId(
		smsMessageID: number,
		queryParams?: Record<string, string>,
	) {
		const response = await axiosInstance.get(
			`/app/smsMessages/${smsMessageID}/smsMessageRecipients`,
			{
				params: { ...queryParams },
			},
		);

		return response.data;
	}

	async getAllExpectedBySmsMessageId(
		smsMessageID: number,
		queryParams?: Record<string, string>,
	) {
		const response = await axiosInstance.get(
			`/app/smsMessages/${smsMessageID}/smsMessageRecipients/expected`,
			{
				params: queryParams,
			},
		);

		return response.data;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SmsMessageRecipientsService();
